module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eric Schmitz, Ken Doyle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Eric Schmitz")]), _vm._v(" is a 12-year Freemason, with a longstanding interest in Arthurian legend and Grail mythology dating back to childhood. He is a Past Master of Monroe Lodge in Bloomington, Indiana, a co-founder of Lodge Vitruvian in Indianapolis, Indiana's premier \"European Concept\" Lodge, and an original \"Knight of the North.\" He has written for the Indiana Freemason magazine, and is a co-author of the pamphlet Laudable Pursuit, a commentary on the past, present and future of Freemasonry in America. He holds degrees in electrical engineering and library science. This is his first book.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5Aijki/images/Cover.jpg?1705842393490",
      "alt": "This image is the cover for the book Weight Training for Cyclists"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Weight Training for Cyclists\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In addition to the powerful quads and chiseled calves they're known for, cyclists need strong core muscles and solid upper-body strength to use their power efficiently. Weight Training for Cyclists is the only book available that shows cyclists how they can get stronger to ride stronger. This revised second edition presents new information on core strength, nutrition, stretching and warm-up. Now comprehensively illustrated with easy-to-follow drawings, the authors explain in clear terms how strength training in the weight room translates to endurance and power on the bike. With the latest research on strength building buttressed by the most recent and effective equipment innovations, Weight Training for Cyclists presents a series of training plans that require only a fraction of the time that cyclists spend in the saddle. For newcomers and veterans alike, Weight Training for Cyclists will become their fundamental guide to better performance.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    VeloPress\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0